// extracted by mini-css-extract-plugin
module.exports = {"container":"miwvymM18yUpo-Rwqs4hhg==","tabs":"_9eNN1CVTzLbfHqM+UDdFTw==","tabsTitle":"_513OFu8nrNe01lD8JjzfUg==","content":"DT04kV8C2tCvc2Wf+TvOKw=="};